module.exports = __webpack_public_path__ + "f8b1ce2d510083fde326a6a7777a021d.svg";